import React from "react";
import Card from "../Card";
import Achievements from "./Achivements";
import CompanyDesc from "./CompanyDesc";
import CompanyOverview from "./CompanyOverview";
import Responsabilities from "./Responsabilities";
import "./workexperience.css";
import Learning from "./Learning";
import Technologies from "./Technologies";
import classNames from "classnames";
import { DottedGradient } from "../Textures/DottedGradient";

export default function WorkSlide({ content, isInteractive, themeKey }) {
  const { mainColor, id, technologies } = content;

  return (
    <div className={classNames("slide", { "slide-dark": themeKey === "dark" })}>
      <div className="slide-content">
        <Card
          frontContent={<CompanyOverview {...content} />}
          backContent={<CompanyDesc id={id} />}
          interactive={isInteractive}
          accentColor={mainColor}
        />
        <Card
          frontContent={<Responsabilities id={id} />}
          backContent={<Learning id={id} />}
          interactive={isInteractive}
          accentColor={mainColor}
        />
        <Card
          frontContent={<Achievements id={id} />}
          backContent={<Technologies technologies={technologies} />}
          interactive={isInteractive}
          accentColor={mainColor}
        />
      </div>
      <div className="dotted-bg">
        <DottedGradient color={themeKey === "dark" ? "#051936" : "#dfe7ed"} />
      </div>
    </div>
  );
}
